import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import PageHeader from '../reusable/PageHeader';
import Panel from '../reusable/Panel';
import Loader from '../reusable/Loader';
import CustomButton from '../reusable/CustomButton';
import SelectDropdown from '../reusable/SelectDropdown';
import useUserDetails from '../hooks/useUserDetails';
import useErrorModal from '../hooks/useErrorModal';
import { getEOAs } from '../../services/userService';
import { EOAListItem } from '../../interfaces/UserDetailsInterface';
import {
  configurationLandingItems,
  continueConfigurationPath,
  createNewConfigurationPath,
} from './configurationLanding';
import './ConfigurationLandingPage.css';

const ConfigurationLandingPage = () => {
  const navigate = useNavigate();
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();
  const { handleOpen: handleOpenErrorModal } = useErrorModal();
  const [eoas, setEoas] = useState<EOAListItem[] | null>(null);

  useEffect(() => {
    const accessToken = userDetails?.access_token;
    if (!accessToken) return;

    const loadEoas = async () => {
      try {
        const response = await getEOAs(accessToken, undefined, true);
        setEoas(response.data.eoas);
      } catch (error) {
        handleOpenErrorModal('Error occurred while loading EOAA configurations!', error as AxiosError);
        setEoas([]);
      }
    };

    void loadEoas();
  }, [userDetails?.access_token, handleOpenErrorModal]);

  const items = configurationLandingItems(eoas ?? []);

  return (
    <>
      <PageHeader title="Configuration" />
      <div className="main-content configuration-landing">
        {!eoas ? (
          <Loader />
        ) : (
          <Panel className="configuration-landing-panel">
            <h2 className="configuration-landing-title">Select an EOAA to configure</h2>
            {items.length > 0 ? (
              <SelectDropdown
                label="Select an EOAA"
                selectedValue=""
                handleChange={(event) => {
                  const eoaId = String(event.target.value);
                  if (!eoaId) return;
                  navigate(continueConfigurationPath(eoaId));
                }}
                items={items}
                formControlVariant="standard"
                isClearable={false}
                containerClasses={['configuration-landing-select']}
              />
            ) : null}
            <CustomButton
              variant="primary"
              size="medium"
              buttonText="Create new EOAA"
              buttonAction={() => navigate(createNewConfigurationPath)}
            />
          </Panel>
        )}
      </div>
    </>
  );
};

export default ConfigurationLandingPage;
